import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Sparkles, CalendarHeart, MapPin } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import UserBadge from "./UserBadge";

const tabs = [
  { to: "/", label: "Home", icon: Home, testid: "tab-home" },
  { to: "/services", label: "Services", icon: Sparkles, testid: "tab-services" },
  { to: "/book", label: "Book", icon: CalendarHeart, testid: "tab-book" },
  { to: "/contact", label: "Contact", icon: MapPin, testid: "tab-contact" },
];

export const Layout = ({ children }) => {
  const location = useLocation();
  return (
    <div className="mobile-shell relative">
      <div className="mx-auto w-full max-w-md min-h-screen bg-cream relative overflow-x-hidden pb-28">
        <div className="absolute top-4 right-4 z-30">
          <UserBadge />
        </div>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Bottom nav */}
      <nav
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[92%] max-w-sm"
        data-testid="bottom-nav"
      >
        <div className="backdrop-blur-2xl bg-white/80 border border-white/60 shadow-glow rounded-full px-2 py-2 flex items-center justify-between">
          {tabs.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.to === "/"}
                data-testid={t.testid}
                className={({ isActive }) =>
                  `flex-1 flex flex-col items-center justify-center py-2 rounded-full transition-all ${
                    isActive
                      ? "text-espresso"
                      : "text-mocha hover:text-espresso"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
                        isActive ? "bg-blush/40 shadow-glow" : ""
                      }`}
                    >
                      <Icon
                        size={20}
                        strokeWidth={isActive ? 2.2 : 1.5}
                        className={isActive ? "text-espresso" : "text-mocha"}
                      />
                    </div>
                    <span
                      className={`text-[10px] mt-0.5 tracking-wide ${
                        isActive ? "text-espresso font-medium" : "text-mocha"
                      }`}
                    >
                      {t.label}
                    </span>
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default Layout;
